module.exports = __webpack_public_path__ + "img/login2.13620718.png";